import Moment from 'moment'

const InboxFilters = {
    shortDate(value) {
        return (new Moment(value)).format('MMM DD')
    }
}
export { InboxFilters }